import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import IconAvatars from './IconAvatars';
import ClientProvider from './client';
export default createDemo(import.meta.url, IconAvatars, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/avatars/demos/icon/IconAvatars.tsx",
    "fileName": "IconAvatars.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { green, pink } from '@mui/material/colors';\nimport Avatar from '@mui/material/Avatar';\nimport Stack from '@mui/material/Stack';\nimport FolderIcon from '@mui/icons-material/Folder';\nimport PageviewIcon from '@mui/icons-material/Pageview';\nimport AssignmentIcon from '@mui/icons-material/Assignment';\n\nexport default function IconAvatars() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Avatar>\n        <FolderIcon />\n      </Avatar>\n      <Avatar sx={{ bgcolor: pink[500] }}>\n        <PageviewIcon />\n      </Avatar>\n      <Avatar sx={{ bgcolor: green[500] }}>\n        <AssignmentIcon />\n      </Avatar>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 22,
        "focusedLines": 9,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { green, pink } from '@mui/material/colors';\nimport Avatar from '@mui/material/Avatar';\nimport Stack from '@mui/material/Stack';\nimport FolderIcon from '@mui/icons-material/Folder';\nimport PageviewIcon from '@mui/icons-material/Pageview';\nimport AssignmentIcon from '@mui/icons-material/Assignment';\n\nexport default function IconAvatars() {\n  return (\n    <Stack direction=\"row\" spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Avatar>\n        <FolderIcon />\n      </Avatar>\n      <Avatar sx={{ bgcolor: pink[500] }}>\n        <PageviewIcon />\n      </Avatar>\n      <Avatar sx={{ bgcolor: green[500] }}>\n        <AssignmentIcon />\n      </Avatar>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "FolderIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "pink"
              ],
              "[",
              [
                "span",
                "pl-c1 di-num",
                "500"
              ],
              "] }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "PageviewIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "bgcolor"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "green"
              ],
              "[",
              [
                "span",
                "pl-c1 di-num",
                "500"
              ],
              "] }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AssignmentIcon"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Avatar"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 22,
    "focusedLines": 9,
    "collapsible": true,
    "externals": [
      "@mui/material/colors",
      "@mui/material/Avatar",
      "@mui/material/Stack",
      "@mui/icons-material/Folder",
      "@mui/icons-material/Pageview",
      "@mui/icons-material/Assignment"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
